import React from "react";
import "./Home.css";
import CV from "../../reuseable/CV/CV";
import shihab from "../../assests/images/shihab.png";
import Socalmedia from "../../reuseable/Socalmedia/Socalmedia";
import Copyright from "../../reuseable/Copyright/Copyright";
import SmallCircle from "../../reuseable/SmallCircle/SmallCircle";
function Home() {
  return (
    //  ----------------          Home Start           ---------------

    <div className="home container">
      {/* ---------------------- information wrapper start ---------------- */}
      <div className="info-wrapper">
        {/* -------------------- top section -----------------  */}
        <div className="home-top">
          <SmallCircle />
          <div className="for-work">
            <div className="for-work-light"></div>
            <h4 className="available-for-work">Available for work</h4>
          </div>
        </div>
        <h1 className="shihab-title">I'm Shihab Ahmed</h1>

        {/* ----------------- profile info section ------------------ */}
        <div className="home-professional-profile">
          <div className="my-professional-describtion">
            <p className="my-describtion">
              Passionate and dedicated{" "}
              <small className="swe">#Software Engineer</small> with expertise
              in{" "}
              <small className="mern">
                Front-End, Mobile Appdevelopment (React Native)
              </small>
              . and <small className="mern">Back-End development</small> as
              needed. I have strong foundations in{" "}
              <small className="mern"> Problem Solving,</small>{" "}
              <small className="mern">JavaScript/TypeScript,</small>{" "}
              <small className="mern">DSA</small>. I have solid Foundation of
              Computer Science.
            </p>

            <div className="socal-section">
              <CV />
              <Socalmedia />
            </div>
          </div>
          <img
            src={shihab}
            alt=""
            className="shihab-image"
            rel="noopener noreferrer"
          />
        </div>
        <Copyright />
      </div>
    </div>
  );
}

export default Home;
